import React from 'react';
import { Typography } from '@mui/material';

export interface SectionLabelProps {
  children: React.ReactNode;
}

/**
 * Small uppercase overline label used to introduce a group of
 * controls or content. Relies on the theme's overline typography
 * variant for uppercase transform + letter-spacing.
 */
export const SectionLabel: React.FC<SectionLabelProps> = ({ children }) => {
  return (
    <Typography
      variant="overline"
      component="div"
      color="text.secondary"
    >
      {children}
    </Typography>
  );
};

export default SectionLabel;
